export default {
  template_list: [],
  templateListMetaData: {},
  dynamicTextList: [],
  dynamicTextList: [],
  studentList: [],
  teacherList: [],
  classList: [],
  courseList: [],
  classListMetaData: {},
  classDetail: {},
}
